import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import TableComponents from '../../../../commonComponents/TableComponents';
import OrderActions from '../../OrderActions';
import useSchema from '../../Schema';

function DataTableOrder({
  selectedTab,
  setSelectedItem,
  isLoading,
  limit,
  setLimit,
  currentPage,
  setCurrentPage,
  total,
  handlePageChange,
  onRowClicked,
  data = [],
  unAssignOrder,
  height,
  handlerModal,
  isModalVisible,
  handlerHistoryModal,
  expandableRowExpanded,
}) {
  const { t } = useTranslation();
  const schema = useSchema();
  const tableHeight = window.innerHeight - (height + 250);

  return (
    <TableComponents
      noDataComponent={<div style={{ padding: '24px' }}>{t('orders_no_records')}</div>}
      columns={schema}
      data={data}
      fixedHeader
      pagination
      paginationDefaultPage={currentPage}
      contextMessage={{ singular: t('item'), plural: t('items'), message: t('selected') }}
      fixedHeaderScrollHeight={tableHeight.toString() + 'px'}
      paginationRowsPerPageOptions={[100, 200, 400, 600]}
      onChangeRowsPerPage={(currentRowsPerPage) => {
        setLimit(currentRowsPerPage);
        setCurrentPage(1);
      }}
      paginationPerPage={+limit}
      progressPending={isLoading}
      paginationTotalRows={total}
      progressComponent={<div className="wait">{t('please_wait')}</div>}
      paginationServer
      subHeader
      onChangePage={handlePageChange}
      conditionalRowStyles={conditionalRowStyles}
      paginationComponentOptions={{
        rowsPerPageText: t('total_record'),
        rangeSeparatorText: t('from'),
        noRowsPerPage: false,
        selectAllRowsItem: false,
      }}
      selectableRows
      selectableRowSelected={(row) => row.isSelected}
      onSelectedRowsChange={(row) => setSelectedItem(row.selectedRows)}
      selectableRowsVisibleOnly
      persistTableHead
      selectableRowsHighlight
      direction={'rtl'}
      onRowClicked={onRowClicked}
      expandableRows={selectedTab === 'fake_order' ? false : true}
      expandableRowsHideExpander
      expandOnRowClicked
      expandableRowsComponent={
        <OrderActions
          data={(row) => row}
          unAssignOrder={unAssignOrder}
          handlerModal={handlerModal}
          isModalVisible={isModalVisible}
          handlerHistoryModal={handlerHistoryModal}
        />
      }
      customStyles={customStylesTable}
      expandableRowExpanded={expandableRowExpanded}
    />
  );
}
export default memo(DataTableOrder);
export const conditionalRowStyles = [
  {
    when: (row) => row.driver,
    style: {
      backgroundColor: '#F8EECC',
    },
  },
  {
    when: (row) => row.isCanceled,
    style: {
      backgroundColor: '#F7DDDE',
    },
  },
  {
    when: (row) => row.isDelivered,
    style: {
      backgroundColor: '#D4E9D8',
    },
  },
];
const customStylesTable = {
  headCells: {
    style: {
      fontWeight: 'bold',
      fontSize: 12,
      background: '#F9F9F9',
      justifyContent: 'flex-start',
      padding: 0,
    },
  },
  rows: {
    style: {
      cursor: 'pointer',
      fontSize: 12,
    },
  },
  header: {
    style: {
      minHeight: 0,
    },
  },
  subHeader: {
    style: {
      minHeight: 0,
    },
  },
};
